/* 
* 排名 点击显示的内容
 */
<template>
  <div class="seller-assistant-ranking-chart">
    <div class="chart-header">
      <span class="chart-header_label">排名</span>
      <span></span>
    </div>
    <div class="chart-label">
      <div class="chart-label_asin">
        <div class="asin-img">
          <gj-image
            :size="50"
            :src="row.imageUrl"
            tag-color="rgb(246,144,10)"
            >
          </gj-image>
        </div>
        <div class="asin-content">
          <div class="asin-content_label">ASIN:</div>
          <div class="asin-content_inner">{{row.asin | defaultShow}}</div>
        </div>
      </div>
     <Typeranking 
      :title="rankingData.mainSellerCategory"
      :bigTypeRank="rankingData.mainSellerRank"
      :lastDay="rankingData.mainSellerRankThan"
      :lastWeek="rankingData.lastWeekMainSellerRankThan"
     />
     <Typeranking 
      type="seller"
      :title="rankingData.sellerCategory"
      :bigTypeRank="rankingData.sellerRank"
      :lastDay="rankingData.sellerRankThan"
      :lastWeek="rankingData.lastWeekSellerRankThan"/>
    </div>
    <div class="chars-content">
      <ve-line
        width="800px"
        height="350px"
        :data-empty="chartRankingData.empty"
        :data="chartRankingData.data"
        :settings="chartRankingData.settings"
        :extend="chartRankingData.options"
      ></ve-line>
    </div>

  </div>
</template>

<script>
import { generatorSalesRankingChartData } from "modules/statistics/asin-361-analysis/config";
import Typeranking from './type-ranking'
export default {
  components: {
    Typeranking
  },
  props: {
    rankingData: {
      type: Object
    },
    row: {
      type: Object,
      default: _ => ({}) 
    }
  },
  data() {
    return {
      loading: {
        hours: false,
        histogram: false,
        line: false,
        pieOne: false,
        pieTwo: false
      }
    };
  },
  computed: {
    chartRankingData({ rankingData1 = {} }) {
      let { statisticsData = [], thanData = [] } = this.rankingData;
      let columns = ["dateLine", "mainSellerRank", "sellerRank"];
      let leftMaxY = this._.max(
        statisticsData.map(item => item.mainSellerRank)
      ) + 10;
      let rightMaxY = this._.max(
        statisticsData.map(item => item.sellerRank)
      ) + 10;
      let rows = statisticsData.map((v, i) => ({
        dateLine: v.dateLine,
        mainSellerRank: v.mainSellerRank ? v.mainSellerRank : leftMaxY,
        sellerRank: v.sellerRank ? v.sellerRank : rightMaxY
      }));
      let options = generatorSalesRankingChartData(
        statisticsData,
        thanData
      )
      options.tooltip.formatter = function(params) {
        let [ param = {} ] = params
        let { dataIndex = 0 } = param
        let rankingItem = statisticsData[dataIndex] || {}
        let thanItem = thanData[dataIndex] || {}

        return `
        <div class="rank-tooltip-box">
          <div class="rank-tooltip-box_now">
            <div class="rank-tooltip-box_now-title rank-tooltip-item">
              <div class="rank-tooltip-item-left">${rankingItem.dateLine}</div>
              <div class="rank-tooltip-item-right">排名</div>
            </div>
            <div class="rank-tooltip-item">
              <div class="rank-tooltip-item-left">${rankingItem.mainSellerCategory || '-'}</div>
              <div class="rank-tooltip-item-right">${rankingItem.mainSellerRank || '-'}</div>
            </div>
            <div class="rank-tooltip-item">
              <div class="rank-tooltip-item-left">${rankingItem.sellerCategory || '-'}</div>
              <div class="rank-tooltip-item-right">${rankingItem.sellerRank || '-'}</div>
            </div>
          </div>
          <div class="rank-tooltip-box_week">
            <div class="rank-tooltip-box_now-title rank-tooltip-item">
              <div class="rank-tooltip-item-left">上周同期同日 ${thanItem.dateLine}</div>
              <div class="rank-tooltip-item-right">排名</div>
            </div>
            <div class="rank-tooltip-item">
              <div class="rank-tooltip-item-left">${thanItem.mainSellerCategory || '-'}</div>
              <div class="rank-tooltip-item-right">${thanItem.mainSellerRank || '-'}</div>
            </div>
            <div class="rank-tooltip-item">
              <div class="rank-tooltip-item-left">${thanItem.sellerCategory || '-'}</div>
              <div class="rank-tooltip-item-right">${thanItem.sellerRank || '-'}</div>
            </div>
          </div>
        </div>`
      }
      options.yAxis = (item) => {
          item[0].splitNumber = 5
          item[0].interval = Math.ceil(leftMaxY / 5)
          item[0].min = 0
          item[0].max = Math.ceil(leftMaxY / 5) * 5
          item[0].inverse = true;
          item[0].splitLine = {
            lineStyle: {
              type: 'dashed'
            }
          }
          item[1].splitNumber = 5
          item[1].interval = rightMaxY > 1 ? Math.ceil((rightMaxY * 100) / 5) / 100 : 1 / 5
          item[1].min = 0
          item[1].max = rightMaxY > 1 ? (Math.ceil((rightMaxY * 100) / 5) * 5) / 100 : 1
          item[1].inverse = true;
          item[1].splitLine = {
            lineStyle: {
              type: 'dashed'
            }
          }
          return item
      }
      return {
        data: {
          columns,
          rows
        },
        settings: {
          labelMap: {
            dateLine: "日期",
            mainSellerRank: "大类排名",
            sellerRank: "小类排名"
          },
          axisSite: {
              right: ['sellerRank']
          }
        },
        options,
        empty: !rows.length
      };
    }
  }
};
</script>

<style lang="scss">
.seller-assistant-ranking-chart {
  width: 900px;
  .chart-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e5e5;
    .chart-header_label {
      color: #333;
      font-weight: 600;
      font-size: 16px;
    }
  }
  .chart-label {
    display: flex;
    margin-top: 20px;
    padding: 0 30px;
    box-sizing: border-box;
    .chart-label_asin {
      display: flex;
      color: #333;
      align-items: center;
      .asin-img {}
      .asin-content {
        margin-left: 8px;
        .asin-content_label {
          color: #333;
          font-size: 14px;
          font-weight: 600;
        }
        .asin-content_inner {
          color: #333;
          font-size: 14px;
          font-weight: 600;
          margin-top: 4px;
        }
      }
    }
  }
  .chars-content {
    width: 800px;
    margin: 40px auto 30px;
    // margin-top: 40px;
  }
  
  .rank-tooltip-box {
    color: #fff;
    font-size: 12px;
    width: 220px;
    padding: 0 10px;
    box-sizing: border-box;
    white-space: normal !important;
    .rank-tooltip-box_now {
      width: 100%;
    }
    .rank-tooltip-box_week {
      margin-top: 20px;
    }
    .rank-tooltip-item {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .rank-tooltip-item-left {
        width: 80%;
      }
      .rank-tooltip-item-right {
        flex: 1;
      }
    }
  }
}
</style>